import {
  RAW_MATERIAL_KINDS,
  RAW_MATERIAL_KIND_LABELS,
  type RawMaterial,
  type RawMaterialKind,
} from "@artisancode/api-types";
import { useWatch, type UseFormReturn } from "react-hook-form";

import { SearchableSelect } from "@/components/shared/searchable-select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { RawMaterialFormValues } from "./raw-material-schema";

const KIND_HINTS: Record<RawMaterialKind, string> = {
  purchased:
    "Dibeli & disimpan utuh per kemasan (contoh: Susu Diamond UHT 1L). Dibuka lewat repacking menjadi bahan resep.",
  ingredient:
    "Dipakai di resep dengan nama umum dan satuan resep (contoh: Susu UHT dalam mL).",
  direct:
    "Dibeli dan dipakai per pcs tanpa dibuka (contoh: cup, sedotan, Yakult).",
};

export function RawMaterialKindFields({
  form,
  ingredientList,
  kindLocked,
  disabled,
}: {
  form: UseFormReturn<RawMaterialFormValues>;
  ingredientList: RawMaterial[];
  kindLocked: boolean;
  disabled: boolean;
}) {
  const kind = useWatch({ control: form.control, name: "kind" });
  return (
    <>
      <FormField
        control={form.control}
        name="kind"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Tipe Barang</FormLabel>
            <Select
              value={field.value}
              onValueChange={field.onChange}
              disabled={kindLocked || disabled}
            >
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {RAW_MATERIAL_KINDS.map((k) => (
                  <SelectItem key={k} value={k}>
                    {RAW_MATERIAL_KIND_LABELS[k]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              {kindLocked
                ? "Tipe tidak dapat diubah karena sudah memiliki riwayat pergerakan stok."
                : KIND_HINTS[field.value]}
            </p>
            <FormMessage />
          </FormItem>
        )}
      />

      {kind === "purchased" && (
        <div>
          <FormField
            control={form.control}
            name="ingredientId"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Dibuka Menjadi</FormLabel>
                <FormControl>
                  <SearchableSelect
                    value={field.value ?? ""}
                    onChange={field.onChange}
                    options={ingredientList.map((i) => ({
                      value: i.id,
                      label: i.name,
                      hint: i.uom?.symbol,
                    }))}
                    placeholder="Pilih bahan resep..."
                    disabled={disabled}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      )}
    </>
  );
}
